import {Box, Button, ButtonProps, Desktop, Heading, Text} from '@miro-site/core'

import React from 'react'
import {useTheme} from 'styled-components'
import {TemplateActions} from '../../template-card/templateActions'

export interface StickyUseTemplateDesktopProps {
  templateActions: TemplateActions
  boardId: string
  headline: string
  description?: string
  actionButtonProps?: Partial<ButtonProps>
}

const StickyUseTemplateDesktop: React.FC<StickyUseTemplateDesktopProps> = ({
  boardId,
  templateActions,
  headline,
  description = 'Get started with this template right now.',
  actionButtonProps,
}) => {
  const theme = useTheme()

  return (
    <Desktop
      data-track-place="sticky-use-template"
      $mt={68}
      $styles={{
        position: 'sticky',
        top: 112,
      }}
    >
      <Box
        $py={24}
        $pl={24}
        $pr={30}
        $styles={{
          borderColor: theme.templates.colors.secondary20,
          borderStyle: 'solid',
          borderWidth: '1px',
          borderRadius: 16,
        }}
      >
        <Heading $variant="h3" $mb={8}>
          {headline}
        </Heading>
        <Text $variant="p2" $styles={{color: theme.templates.colors.secondary60}} $mb={48}>
          {description}
        </Text>
        {actionButtonProps ? (
          <Button
            data-track-id="use-template"
            data-template-id={boardId}
            $buttonType="primary"
            $size="medium"
            $withArrow
            {...actionButtonProps}
          >
            {actionButtonProps.children || templateActions.USE_TEMPLATE}
          </Button>
        ) : null}
      </Box>
    </Desktop>
  )
}

export default StickyUseTemplateDesktop
